import { useEffect, useState } from 'react'
import { useMutation } from 'Shared/Hooks/useApolloClient'
import { useSelector } from 'react-redux'
import { escapeBlank } from 'Utils/Parse'
import { formatDate } from 'Utils/Dates'
import { useReservationsVariables } from 'Checkout/Hooks/useReservationsVariables'
import purchaseCreateMutation from 'Checkout/Mutations/PurchaseCreateMutation'

const useReservationCreate = () => {
  const buildReservations = useReservationsVariables()
  const [createReservation, { data, error: errorData, loading }] = useMutation(purchaseCreateMutation)
  const reservations = useSelector(state => state.cart.reservations)
  const defaultPayment = useSelector(state => state.payment.defaultPayment)
  const { slug: campgroundSlug, systemType } = useSelector(state => state.campground)
  const [error, setError] = useState()

  useEffect(() => {
    if (errorData) {
      const { graphQLErrors } = errorData
      const errorsList = graphQLErrors.map(graphQLError => graphQLError.message)
      setError(errorsList[0])
    }
  }, [errorData])

  useEffect(() => {
    if (data?.purchaseCreate?.purchase?.reservation) {
      const awinData = window.AWIN

      if (typeof awinData?.Tracking !== 'undefined') {
        const { reservation } = data.purchaseCreate.purchase
        const { balanceGroupingTotal, balanceTotal, from, id, pricing, source, to } = reservation
        const amount = balanceGroupingTotal?.amount || balanceTotal.amount
        const isoDateFormat = 'MM-DD-YYYY'
        awinData.Tracking.Sale = {}
        awinData.Tracking.Sale.amount = amount
        awinData.Tracking.Sale.channel = 'aw'
        awinData.Tracking.Sale.currency = pricing.currencyCode
        awinData.Tracking.Sale.custom = [campgroundSlug, formatDate(from, { format: isoDateFormat }),
                                         formatDate(to, { format: isoDateFormat }), systemType, source]
        awinData.Tracking.Sale.orderRef = id
        awinData.Tracking.Sale.parts = `DEFAULT:${amount}`
        awinData.Tracking.run()
      }
    }
  }, [data])

  const buildVariables = card => ({
    campgroundId: campgroundSlug,
    initialPaymentSource: 'stripe',
    reservations: buildReservations(true),
    source: 'online',
    ...buildPaymentMethod(card),
  })

  const buildPaymentMethod = card => {
    if (card.id)
      return { paymentMethodId: card.id }

    return { paymentMethod: { isDefaultSource: defaultPayment, stripeToken: escapeBlank(card.token) } }
  }

  const createReservationMethod = card => {
    if (reservations.length > 0) {
      createReservation({ variables: { input: buildVariables(card) } })
      setError(null)
    } else setError('Missing data, please edit the reservation and ensure everything is right.')
  }

  return [createReservationMethod, data, error, loading]
}

export default useReservationCreate
